/**
 * Manifest URL Configuration
 *
 * Determines the manifest URL based on environment.
 * - Development: Uses local filesystem (/scores_library/manifest.json)
 * - Production: Uses Vercel Blob URL from environment variable
 */

/**
 * Get the manifest URL based on current environment
 * @param bustCache - Add cache-busting query param (useful after saves)
 */
export function getManifestUrl(bustCache = false): string {
  let url: string;

  // Use Blob URL if configured (works in both dev and production)
  // This ensures save and load use the same source
  if (import.meta.env.VITE_BLOB_MANIFEST_URL) {
    url = import.meta.env.VITE_BLOB_MANIFEST_URL;
  } else {
    // Fallback to local filesystem
    url = '/scores_library/manifest.json';
  }

  // Add cache-busting query param if requested
  if (bustCache) {
    const separator = url.includes('?') ? '&' : '?';
    url = `${url}${separator}_t=${Date.now()}`;
  }

  return url;
}

/**
 * Get the course manifest URL based on current environment
 * @param bustCache - Add cache-busting query param (useful after saves)
 */
export function getCourseManifestUrl(bustCache = false): string {
  let url: string;

  if (import.meta.env.VITE_BLOB_COURSE_MANIFEST_URL) {
    url = import.meta.env.VITE_BLOB_COURSE_MANIFEST_URL;
  } else {
    url = '/courses/manifest.json';
  }

  if (bustCache) {
    const separator = url.includes('?') ? '&' : '?';
    url = `${url}${separator}_t=${Date.now()}`;
  }

  return url;
}

/**
 * Check if we're using Blob storage (production mode with Blob URL)
 */
export function isUsingBlobStorage(): boolean {
  return !import.meta.env.DEV && !!import.meta.env.VITE_BLOB_MANIFEST_URL;
}
